import { createRoute } from '@tanstack/react-router'

import { createValidateSearch } from '@campai/lib-web/routes'

import { rootRoute } from '@/product/feedback/root'
import { SearchSchema } from '@/product/feedback/home/routeUtils'

import { Home } from './Home'

export const homeRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/',
    component: Home,
    validateSearch: createValidateSearch(SearchSchema),
})
